/*
 * The attribute that says "this head tag was written at build time".
 *
 * WHY IT NEEDS ITS OWN MODULE. Four very different callers agree on this one
 * string: src/scripts/injectHeadTags.js stamps it, scripts/verifyInjectedHead.js
 * and tests/hosting/hostingRouting.js look for it before a deploy, and
 * src/scripts/staticHeadDedupe.js -- which ships in the browser bundle --
 * removes tags carrying it. The first three are plain-node scripts that read
 * the filesystem; the last must never pull `fs` into the app bundle, so it
 * cannot import the injector. A shared constant is the only way all four can be
 * wrong together rather than one of them being wrong alone, which is the
 * failure that leaves duplicate og:title tags on a served page.
 *
 * CommonJS for the same reason as src/data/siteOrigin.js: node's own require()
 * loads it in the build scripts, and webpack/vitest import it from app code
 * without ceremony.
 */

const MARKER_ATTR = "data-al-head";
const MARKER_VALUE = "static";

/** CSS selector for every tag the build-time injector owns. */
const STATIC_HEAD_SELECTOR = `[${MARKER_ATTR}="${MARKER_VALUE}"]`;

module.exports = {
  MARKER_ATTR,
  MARKER_VALUE,
  STATIC_HEAD_SELECTOR,
};
